import ApiService from './ApiService.js'
import ApiHelper from './ApiHelper.js'

export default {
    getByID(id) {
        let header = ApiHelper.getHeader();
        return ApiService().get('/api/cards/' + id,
            { 
                headers: header
            });
    },
    assignMember(id, data) {
        let header = ApiHelper.getHeader();
        return ApiService().post('/api/cards/' + id + '/members', data, {
            headers: header
        });
    },
    removeMember(cardId, memgerId) {
        let header = ApiHelper.getHeader();
        return ApiService().delete('/api/cards/' + cardId + '/members/' + memgerId, {
            headers: header
        });
    }
}